import { useEffect, useRef } from 'react';
import { supabase } from '../lib/supabase';

// Calls onChange(payload) shortly after any insert / update / delete on the given tables (made by anyone, including this user).
// The latest onChange is always used, and the channel is removed when the page closes.
export default function useLiveRefresh(tables, onChange, enabled = true, delay = 1200) {
  const cbRef = useRef(onChange);
  useEffect(() => { cbRef.current = onChange; });
  const key = tables.join(',');
  useEffect(() => {
    if (!enabled) return undefined;
    let timer = null;
    let last = null;
    let ch = supabase.channel('live-' + key.replace(/,/g, '-') + '-' + Math.random().toString(36).slice(2, 8));
    key.split(',').forEach(tb => {
      ch = ch.on('postgres_changes', { event: '*', schema: 'public', table: tb }, payload => {
        last = payload;
        clearTimeout(timer);
        timer = setTimeout(() => { try { cbRef.current(last); } catch (e) { /* a failed refresh must never break the page */ } }, delay);
      });
    });
    ch.subscribe();
    return () => { clearTimeout(timer); supabase.removeChannel(ch); };
  }, [key, enabled, delay]);
}
